import axios from 'axios';

const getUnread = threads =>
    threads.map(x => x.unread).reduce((x, y) => parseInt(x) + parseInt(y), 0);

export default {
    namespaced: true,
    state: {
        unreadCount: 0,
        threads: null,
        contactId: null,
        messages: null,
        loadingThreads: false,
        loadingMessages: false
    },
    getters: {
        contact(state) {
            return state.threads.find(thread => thread.id === state.contactId);
        }
    },
    mutations: {
        loadThreads(state) {
            state.loadingThreads = true;
        },
        loadMessages(state, contactId) {
            state.loadingMessages = true;
            state.contactId = contactId;
        },
        updateUnreadMessageCount(state, unreadCount) {
            state.unreadCount = parseInt(unreadCount);
        },
        updateThreads(state, threads) {
            state.threads = threads;
            state.unreadCount = getUnread(state.threads);
            state.loadingThreads = false;
        },
        updateMessages(state, messages) {
            state.messages = messages;
            state.loadingMessages = false;
        },
        addMessage(state, message) {
            state.unreadCount += 1;
            var contact = state.threads.find(x => x.id === message.contactId);
            if (contact) {
                contact.message_id = message.id;
                contact.type = message.type;
                contact.text = message.text;
                contact.created_at = message.created_at;
                contact.unread += 1;
            }
            state.messages.push(message);
        },
        markCurrentThreadRead(state) {
            state.threads.find(x => x.id === state.contactId).unread = 0;
            state.unreadCount = getUnread(state.threads);
        }
    },
    actions: {
        getUnreadCount({ commit }) {
            commit('updateUnreadMessageCount', 0);
            axios
                .get('/messages/get-unread')
                .then(result => {
                    commit('updateUnreadMessageCount', result.data);
                })
                .catch(console.error);
        },
        getThreads({ commit }, top) {
            commit('loadThreads');
            return axios
                .get('/messages/get-threads', {
                    params: { top }
                })
                .then(result => {
                    commit('updateThreads', result.data.data);
                })
                .catch(console.error);
        },
        getMessages({ commit }, contactId) {
            commit('loadMessages', contactId);
            return axios
                .get('/messages/get-messages', {
                    params: { contactId }
                })
                .then(result => {
                    var messages = result.data.data;
                    commit('updateMessages', messages);
                })
                .catch(console.error);
        },
        sendMessage(context, { text, contactId }) {
            return axios
                .post('/message', {
                    userId: contactId,
                    text: text
                })
                .catch(console.error);
        },
        setRentalState(context, data) {
            return axios.post('/rental/setState', data).catch(console.error);
        },
        markRead({ commit, state }, contactId) {
            commit('markCurrentThreadRead');
            if (state.messages.some(x => !x.isRead)) {
                axios
                    .post('/messages/mark-read', { contactId })
                    .catch(console.error);
            }
        }
    }
};
